import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=c07ff388&scoped=true"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"
import style0 from "./Tasks.vue?vue&type=style&index=0&id=c07ff388&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07ff388",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c07ff388')) {
      api.createRecord('c07ff388', component.options)
    } else {
      api.reload('c07ff388', component.options)
    }
    module.hot.accept("./Tasks.vue?vue&type=template&id=c07ff388&scoped=true", function () {
      api.rerender('c07ff388', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Task/Tasks.vue"
export default component.exports